import NotificationSettingNotesActivities from "@app/types/notifications/NotificationSettingNotesActivities";

const getNotesActivitiesUpdate = (enabled: boolean): NotificationSettingNotesActivities => ({
  activityAssigned: {
    activityCompleted: enabled,
    activityTimeChanged: enabled,
    enabled,
    incompleteActivityEndReminder: enabled,
    noteOnAssignedActivity: enabled,
  },
  activityOwned: {
    activityCompleted: enabled,
    activityTimeChanged: enabled,
    enabled,
  },
  enabled,
  ownedRecord: {
    activityOnOwnedRecord: enabled,
    enabled,
    noteOnOwnedRecord: enabled,
  },
});

export default getNotesActivitiesUpdate;
